import React, { useState, useEffect } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import JsonViewer from "../../Custom/JsonViewer";

export default function V2LiveViewer() {
  const v2 = useSelector((state: RootState) => state.aks.v2, isEqual);
  const [v2Copy, setV2Copy] = useState<typeof v2>({} as typeof v2);
  const hasSetInitial = React.useRef(false);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchText), 300);
    return () => clearTimeout(timer);
  }, [searchText]);

  useEffect(() => {
    if (!hasSetInitial.current && !isEqual(v2, {})) {
      setV2Copy(v2);
      hasSetInitial.current = true;
    }
  }, [v2]);

  function refreshButtonClick() {
    setV2Copy(v2);
  }

  const isEmpty = !v2Copy || Object.keys(v2Copy).length === 0;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.searchContainer}>
          <input
            type="text"
            className={styles.searchInput}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search..."
          />
        </div>
        <button className={styles.refreshButton} onClick={refreshButtonClick}>
          Refresh
        </button>
      </div>
      {isEmpty ? (
        <div className={styles.emptyMessage}>No data available</div>
      ) : (
        <div className={styles.jsonContainer}>
          {Object.entries(v2Copy).map(([key, value]) => (
            <JsonViewer
              key={key}
              data={value}
              rootName={key}
              searchText={debouncedSearch}
              defaultExpanded={false}
              showFullBranchOnMatch={true}
            />
          ))}
        </div>
      )}
    </div>
  );
}
